var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCalendar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3335 1.32443H3.66589V2.65608H3.33333C2.59695 2.65608 2 3.25303 2 3.98941V12.6561C2 13.3925 2.59695 13.9894 3.33333 13.9894H12.6667C13.403 13.9894 14 13.3925 14 12.6561V3.98941C14 3.25303 13.403 2.65608 12.6667 2.65608H12.3337V1.32443H10.6661V2.65608H5.3335V1.32443ZM3.1687 6.17121C3.1687 5.98712 3.31794 5.83788 3.50203 5.83788H12.492C12.6761 5.83788 12.8253 5.98712 12.8253 6.17121V12.4927C12.8253 12.6768 12.6761 12.8261 12.492 12.8261H3.50203C3.31794 12.8261 3.1687 12.6768 3.1687 12.4927V6.17121ZM4.67196 7.32611H5.9943V8.64846H4.67196V7.32611ZM4.67196 10.002H5.9943V11.3244H4.67196V10.002ZM8.66117 7.32611H7.33883V8.64846H8.66117V7.32611ZM7.33883 10.002H8.66117V11.3244H7.33883V10.002ZM11.3273 8.64846V7.32611H10.005V8.64846H11.3273ZM10.005 11.3244V10.002H11.3273V11.3244H10.005Z",
    fill: "#A4A4A4"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.75751b8c.svg";
export { ForwardRef as ReactComponent };